/**
 * SeenSeenDeal
 * 본본 | 이 상품을 본 사람이 함께 본 상품
 * [TM-3424] 본본 상품을 스마트애드 AI 추천 광고상품으로 대체하여 노출 
 */
export default class SeenSeenDeal {
  constructor() {
    const {
      data: { SEEN_SEEN_DEALS = [] } = {},
    } = TMON.oApp.htStorage.intergratedDeals;

    if (!Object.keys(SEEN_SEEN_DEALS).length) return;

    this.recommended = SEEN_SEEN_DEALS;
  }

  /* 본본 Render 정보 */
  getSeenRenderInfo() {
    if (this.recommended) {
      const info = {
        floatYn: '',
        containerRole: '_wrapRecommendDealContainer',
        strongWord: '많이 본 상품이에요.',
        strongClass: '',
        spanClass: '',
        spanWord: '',
        h4Word: ['다른 고객이', ''],
        mobileH4Word: ['다른 고객이 많이 본 상품이에요.', ''],
        landingUrl: '',
        listRole: '_wrapRecommendDeal',
        tlCode: 'VVADDT',
        dataSize: this.recommended.length,
        itemList: this.recommended,
        tlArea: 'VVADD',
        key: 'seenSeenDeal',
      };
      return info;
    }
    return {};
  }
}
